// lib/api.ts
import axios from "axios";

// Validar que las variables de entorno requeridas estén configuradas
// if (!process.env.NEXT_PUBLIC_BASE_URL_API_NEXT) {
//   throw new Error(
//     "❌ ERROR: NEXT_PUBLIC_BASE_URL_API_NEXT no está configurada en el archivo .env\n" +
//     "Por favor, configura esta variable de entorno antes de iniciar la aplicación."
//   );
// }

// if (!process.env.NEXT_PUBLIC_BASE_PATH) {
//   throw new Error(
//     "❌ ERROR: NEXT_PUBLIC_BASE_PATH no está configurada en el archivo .env\n" +
//     "Por favor, configura esta variable de entorno antes de iniciar la aplicación."
//   );
// }

const basePath = process.env.NEXT_PUBLIC_BASE_PATH;
const apiURL = `${process.env.NEXT_PUBLIC_BASE_URL_API_NEXT}${basePath}`;

export const api = axios.create({
  baseURL: apiURL,
  withCredentials: true,
});

// 🔒 INTERCEPTOR DE SEGURIDAD - Manejo global de 401 (sesión expirada)
api.interceptors.response.use(
  // Si la respuesta es exitosa, simplemente retornarla
  (response) => response,

  // Si hay un error, manejarlo
  (error) => {
    // Verificar si es un error 401 (No autorizado / Token inválido)
    if (error.response?.status === 401) {
      // Obtener la URL de la petición que falló
      const requestUrl = error.config?.url || "";

      // Lista de endpoints que NO deben disparar el logout automático
      // (endpoints donde un 401 es esperado/normal o que manejan su propio 401)
      const excludedEndpoints = [
        "/api/auth/login",
        "/api/auth/register",
        "/api/auth/resetPassword",
        "/api/auth/me", // Este endpoint maneja sus propios 401 en UserContext
        "/api/dashboards/configuracion/change_password", // Validación de contraseña actual
      ];

      // Verificar si la petición es a un endpoint excluido
      const isExcludedEndpoint = excludedEndpoints.some((endpoint) =>
        requestUrl.includes(endpoint)
      );

      // Solo disparar evento de sesión expirada si NO es un endpoint excluido Y estamos en el cliente
      // NO hacemos limpieza aquí para permitir que la alerta se muestre correctamente
      if (!isExcludedEndpoint && typeof window !== "undefined") {
        // Disparar evento personalizado para que UserContext muestre la alerta
        // La limpieza y redirección se hará DESPUÉS de mostrar la alerta
        window.dispatchEvent(
          new CustomEvent("session-expired", {
            detail: {
              title: "Sesión Expirada",
              message:
                "Tu sesión ha expirado por seguridad. Por favor, inicia sesión nuevamente.",
            },
          })
        );
      }
    }

    // Rechazar la promesa para que el error se propague
    return Promise.reject(error);
  }
);
